var shallowMerge = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return Object.assign({}, ...args);
};
export default shallowMerge;